import "./Work.module.css";
import Header from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import Footer from "@/reusable_sections/Footer";
export default function WorkPage() {
  return <div>
      <Header />
      <Portfolio />
      <Footer />
    </div>;
}